// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"380":"5d2b9661","427":"a4c7892a"}[chunkId] + ".chunk.css";
};